import axios from 'axios';
import appConfig from "./app-config";
const baseurl = appConfig.development.apiBaseUrl

const authInterceptor = axios.create();

authInterceptor.interceptors.request.use(
  async config => {
    config.baseURL = baseurl;

    const token = localStorage.getItem('SWAAccessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

authInterceptor.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const { status } = error.response;
  if (status === 401) {
    window.location.href = "/login"
  }
  return Promise.reject(error);
});


export default authInterceptor;